import { SortDescriptor } from "react-aria-components";

import { API_KEY_GROUP_MAPPING_COLUMN_ID } from "../constants";
import { ApiKeyGroupMappingEntity } from "../types";

export const sortGroups = (items: ApiKeyGroupMappingEntity[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string;
    let valueB: string;

    switch (sortDescriptor.column as API_KEY_GROUP_MAPPING_COLUMN_ID) {
      case API_KEY_GROUP_MAPPING_COLUMN_ID.NAME:
        valueA = a.groupName;
        valueB = b.groupName;
        break;
      case API_KEY_GROUP_MAPPING_COLUMN_ID.STATUS:
        valueA = a.status;
        valueB = b.status;
        break;
      case API_KEY_GROUP_MAPPING_COLUMN_ID.DESCRIPTION:
        return 0;
      case API_KEY_GROUP_MAPPING_COLUMN_ID.ACTIONS:
        return 0;
      default:
        return 0;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
